import { Button } from '@chakra-ui/react';
import CompaniesService from 'api/services/CompaniesService';
import Dialog from 'components/Dialog';
import InputMy from 'components/InputMy';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { useAppDispatch } from 'store/hooks';
import { createTeam, fetchTeams } from 'store/slices/teams';

const CreateTeamDialog = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [title, setValue] = useState('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value);

    const handleCreate = async () => {
        try {
            setLoading(true);
            dispatch(createTeam({ title }))
                .then(response => {
                    console.log(response);
                    showMessage('The team has been successfully created.');
                })
                .then(() => {
                    dispatch(fetchTeams());
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            return false;
        }
    };

    return (
        <Dialog
            title="Create a team"
            trigger={
                <Button variant="outline" leftIcon={<FiPlus />} height="40px" padding="0 16px" fontSize="14px">
                    Create team
                </Button>
            }
            submitText="Create team"
            onSubmit={handleCreate}
            disabled={title.length === 0}
            loading={loading}
        >
            <InputMy label="Team name" placeholder="Enter name" value={title} onChange={handleChange} />
        </Dialog>
    );
};

export default CreateTeamDialog;
